module.exports = __webpack_public_path__ + "e8447bf13e42758cdfc04d4f3974690f.svg";